import {Component, HostListener, AfterViewInit, Input} from "@angular/core";
import {PageSpaceFloorItem} from "../../service/page/page";
import * as Swiper from "swiper";

@Component({
  selector: 'app-floor-item',
  templateUrl: './floor-item.component.html',
  styleUrls: ['./floor-item.component.scss'],
})
export class FloorItemComponent implements AfterViewInit {
  @Input() item: PageSpaceFloorItem;
  @Input() location: string;
  @Input() index: Number;

  isMobile: boolean = false;
  config = {
    scrollbar: null,
    direction: 'horizontal',
    slidesPerView: 1,
    scrollbarHide: false,
    keyboardControl: false,
    mousewheelControl: false,
    scrollbarDraggable: true,
    scrollbarSnapOnRelease: true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    autoplayStopOnLast: false,
    autoplayDisableOnInteraction: false,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    autoplay: 300000,
    loop: true,
    pagination: '.swiper-pagination',
    paginationType: 'bullets',
    paginationClickable: true,
  };
  swiper;
  target: string;

  @HostListener('window:resize', ['$event']) onResize(event) {
    let isMobile = (event.target.innerWidth < 768);
    if (this.isMobile != isMobile) {
      this.isMobile = isMobile;
      this.onCarouselInit();
    }
  }

  constructor() { }

  // dynamic class issue
  ngAfterViewInit() {
    this.target = `.swiper-container-floor-item-${this.index}`
    this.swiper = new Swiper(this.target, this.config);
    this.isMobile = (window.innerWidth < 768);
    this.onCarouselInit();
  }

  onCarouselInit() {
    if(this.item.images.length === 1) {
      document.querySelector(this.target).classList.add('one-contents')
      this.swiper.params.loop = false
    } else {
      document.querySelector(this.target).classList.remove('one-contents')
      this.swiper.params.loop = true
    }

    this.swiper.removeAllSlides();
    this.swiper.appendSlide(
      this.item.images.map(
        bannner => `<div class="swiper-slide" style="background-image:url('${this.isMobile ? bannner.mobileImage : bannner.image}')"></div>`
      )
    );
    this.swiper.update(true);
    this.swiper.slideTo(1, 0);
  }
}


// WEBPACK FOOTER //
// ./src/app/space/floor-item/floor-item.component.ts